import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    zIndex: 9,
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[3],
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  right: {
    height: '100%',
    width: '100%',
    backgroundColor: theme.palette.background.paper2,
    zIndex: 9,
    display: 'flex',
    flexDirection: 'column',
  },
  rightHeader: {
    padding: 15,
  },
  rightContent: {
    overflowY: 'auto',
    zIndex: 9,
    scrollBehavior: 'smooth',
    '&::-webkit-scrollbar': {
      width: theme.shape.scrollSize,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.scroll,
      borderRadius: theme.shape.scrollRadius,
    },
  },
  maskLeft: {
    background: `linear-gradient(to bottom, rgba(0,0,0,0) 0%, ${theme.palette.background.paper} 100%);`,
    width: 297,
    height: 50,
    position: 'absolute',
    left: 0,
    bottom: 0,
  },
  maskRight: {
    zindex: 10,
    background: `linear-gradient(to bottom, rgba(0,0,0,0) 0%, ${theme.palette.background.paper2} 100%);`,
    width: 497,
    height: 50,
    position: 'absolute',
    right: 3,
    bottom: 0,
  },
  emptySpace: {
    width: '100vw',
    height: '98vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
}))

export default useStyles
